export default __webpack_public_path__ + "static/media/cliente4.a4afd199.jpg";